// ── CONFIG ─────────────────────────────────────────────
const CLOUD_NAME    = 'dqvcw2ijp';
const UPLOAD_PRESET = 'Shopify_COCOBEAR';  // match EXACT casing in Cloudinary dashboard
// ────────────────────────────────────────────────────────

// FIX: Run setup only after the DOM is ready. The previous version ran
// immediately on script load, which can fire before the form markup above
// it has been parsed. If any getElementById() call returned null, the next
// line (dropzone.addEventListener) threw and silently killed the rest of
// the script -- which is why nothing ever uploaded.
function initCocoBearUpload() {
  const fileInput    = document.getElementById('fileInput');
  const statusEl     = document.getElementById('cb-upload-status');
  const previewImg   = document.getElementById('cb-preview-img');
  const urlField     = document.getElementById('cloudinary-url-field');
  const submitBtn    = document.getElementById('submit-btn');
  const messageField = document.getElementById('ContactMessage');
  const dropzone     = document.getElementById('cb-dropzone');
  const form         = document.querySelector('#cb-dropzone')
                          ? document.getElementById('cb-dropzone').closest('form')
                          : document.querySelector('form');

  // FIX: bail out (with a console warning) instead of throwing, so a
  // missing element on one page never breaks JS for the rest of the site.
  if (!fileInput || !dropzone || !statusEl || !urlField || !submitBtn || !form) {
    console.warn('[cocobear-upload] Required form elements not found, aborting init.', {
      fileInput: !!fileInput,
      dropzone: !!dropzone,
      statusEl: !!statusEl,
      urlField: !!urlField,
      submitBtn: !!submitBtn,
      form: !!form
    });
    return;
  }

  let uploadedUrl = '';

  dropzone.addEventListener('dragover', e => {
    e.preventDefault();
    dropzone.classList.add('dragging');
  });
  dropzone.addEventListener('dragleave', () => {
    dropzone.classList.remove('dragging');
  });
  dropzone.addEventListener('drop', e => {
    e.preventDefault();
    dropzone.classList.remove('dragging');
    if (e.dataTransfer.files[0]) handleFile(e.dataTransfer.files[0]);
  });

  fileInput.addEventListener('change', e => {
    if (e.target.files[0]) handleFile(e.target.files[0]);
  });

  function handleFile(file) {
    if (file.size > 10 * 1024 * 1024) {
      setStatus('error', 'File exceeds 10 MB limit.');
      return;
    }
    if (!file.type.startsWith('image/')) {
      setStatus('error', 'Please select an image file.');
      return;
    }

    // FIX: show an instant local preview via FileReader so the user gets
    // visual feedback immediately, before the network upload finishes.
    // This replaces the old duplicate inline <script> in contact-form.liquid
    // that did the same thing separately (two listeners on one input).
    const reader = new FileReader();
    reader.onload = e => {
      if (previewImg) {
        previewImg.src = e.target.result;
        previewImg.style.display = 'block';
      }
    };
    reader.readAsDataURL(file);

    uploadToCloudinary(file);
  }

  async function uploadToCloudinary(file) {
    setStatus('uploading', 'Uploading…');
    submitBtn.disabled = true;

    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', UPLOAD_PRESET);
    formData.append('folder', 'shopify-contact');

    try {
      const res = await fetch(
        `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`,
        { method: 'POST', body: formData }
      );

      const data = await res.json();

      if (data.error) {
        throw new Error(data.error.message);
      }
      if (!res.ok) {
        throw new Error('Upload failed: ' + res.statusText);
      }

      uploadedUrl = data.secure_url;
      if (previewImg) {
        previewImg.src = uploadedUrl;
        previewImg.style.display = 'block';
      }
      setStatus('success', '✓ Image uploaded');
      submitBtn.disabled = false;
    } catch (err) {
      setStatus('error', 'Upload error: ' + err.message);
      submitBtn.disabled = false;
    }
  }

  // Combine textarea message + image URL into contact[body]
  form.addEventListener('submit', function(e) {
    const note = messageField ? messageField.value.trim() : '';
    const parts = [];
    if (note)        parts.push(note);
    if (uploadedUrl) parts.push('\n\nInspiration image: ' + uploadedUrl);
    urlField.value = parts.join('');

    // Image is optional -- uncomment the 2 lines below to make it required
    // if (!uploadedUrl) {
    //   e.preventDefault();
    //   setStatus('error', 'Please upload an image first.');
    // }
  });

  function setStatus(type, msg) {
    if (!statusEl) return;
    statusEl.textContent = msg;
    statusEl.style.color =
      type === 'error'   ? '#dc2626' :
      type === 'success' ? '#16a34a' : '#563728';
  }
}

// FIX: guard for both load-order cases. If the DOM is already parsed by the
// time this script runs (e.g. it loads slowly / late), document.readyState
// will already be 'interactive' or 'complete', and DOMContentLoaded will
// never fire again -- so we check readyState first instead of only
// listening for the event.
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCocoBearUpload);
} else {
  initCocoBearUpload();
}
